<ng-container>
	<form [formGroup]="form">
		<app-tooltip
			tooltipText="tooltip"
			i18n-tooltipText="@@form.file.forbidden-characters.tooltip">
			<mat-radio-group
				id="{{ cmpId + 'fileName-radio' }}"
				color="primary"
				[formControlName]="ExportFileFormControls.Strategy"
				class="app-export-file-configuration">
				<mat-radio-button
					id="{{ cmpId + 'fileName-radio-opt-' + idx }}"
					*ngFor="let option of fileNamingOptions; let idx = index"
					[value]="option.value">
					{{ option.label }}
				</mat-radio-button>
			</mat-radio-group>
		</app-tooltip>

		<mat-form-field
			class="app-export-file-configuration__user-defined-pattern"
			*ngIf="
				form.get(ExportFileFormControls.Strategy)?.value ===
				FileNameGenStrategy.UserDefinedFileNamePattern
			"
			[appearance]="Appearance">
			<mat-label i18n="@@export.fileName.strategy.userDefinedFileName.new">
				New Label
			</mat-label>
			<input
				type="text"
				matInput
				placeholder="userDefinedFileNamePattern"
				i18n-placeholder="
					@@export.fileName.strategy.userDefinedFileName.new.placeholder"
				id="{{ cmpId + 'filename-user-defined-pattern' }}"
				[formControlName]="ExportFileFormControls.FileName" />
			<mat-error
				*ngIf="
					form
						.get(ExportFileFormControls.FileName)
						?.hasError(ValidationErrorKeys.Required)
				"
				i18n="@@export.fileName.strategy.userDefinedFileName.new.error">
				You must define a file name
			</mat-error>
			<mat-error
				*ngIf="
					form
						.get(ExportFileFormControls.FileName)
						?.hasError(ValidationErrorKeys.ForbiddenCharacters)
				"
				i18n="@@export.fileName.strategy.userDefinedLabel.new.error.pattern">
				forbidden_character
			</mat-error>
			<mat-error
				*ngIf="
					form
						.get(ExportFileFormControls.FileName)
						?.hasError(ValidationErrorKeys.UnrecognizableTimezone)
				"
				i18n="@@export.fileName.strategy.userDefinedLabel.new.error.unknown-timezone">
				unknown_time_zone
			</mat-error>
			<mat-error
				*ngIf="
					form
						.get(ExportFileFormControls.FileName)
						?.hasError(ValidationErrorKeys.IncompleteTimezone)
				"
				i18n="@@export.fileName.strategy.userDefinedLabel.new.error.incomplete-timezone">
				unknown_time_zone
			</mat-error>
			<mat-error
				*ngIf="
					form
						.get(ExportFileFormControls.FileName)
						?.hasError(ValidationErrorKeys.IncompletePattern)
				"
				i18n="@@export.fileName.strategy.userDefinedLabel.new.error.incomplete-pattern">
				incomplete_pattern
			</mat-error>
		</mat-form-field>
		<div class="app-export-file-configuration__customExtensionOptions">
		<app-tooltip
			tooltipText="Enables a custom extension to override the default file format extension (e.g., .bak instead of .csv). If enabled and the field is left empty, the file will have no extension."
			i18n-tooltipText="@@export.fileName.customExtension.tooltip">
			
			<mat-checkbox
			id="{{ cmpId + '-customExtension-chkbx' }}"
			color="primary"
			[formControlName]="ExportFileFormControls.ShouldApplyCustomExtension">
			<span i18n="@@export.fileName.customExtension">
				Custom file extension
			</span>
			</mat-checkbox>
		</app-tooltip>

		<mat-form-field
			id="{{ cmpId + '-customExtension-input' }}"
			[appearance]="Appearance">
			<mat-label i18n="@@export.fileName.customExtensionLabel">Extension</mat-label>
			<input
			type="text"
			matInput
			placeholder="example: bak"
			i18n-placeholder="@@export.fileName.customExtension.placeholder"
			[formControlName]="ExportFileFormControls.CustomExtension" />
		</mat-form-field>
		</div>
	</form>
</ng-container>
